<template>
  <div class="favorite">
    <el-container>
      <el-header>
        <div class="page-title">{{ pageTitle }}</div>
      </el-header>
      <el-main>
        <div class="no-data" v-show="noData">
          <img src="~@/common/img/no_data.png" alt="">
          <span>没有找到相关内容</span>
        </div>
        <div class="item-list" v-show="!noData">
          <div class="item" v-for="(item, index) in itemList" :key="index" @click="goDetail(item)">
            <div class="cover" :style="'background-image: url(' + item.thumbnail_path + ')'">
              <div class="statistics">
                <el-link class="clicks" icon="el-icon-video-play" :underline="false">{{item.click}}</el-link>
                <el-link class="downloads" icon="el-icon-download" :underline="false">{{item.download}}</el-link>
                <el-link class="favorites" icon="el-icon-star-off" :underline="false">{{item.favorite}}</el-link>
              </div>
            </div>
            <div class="intro">
              <div class="name">{{item.name}}</div>
              <div class="teacher">{{item.owner_name}}</div>
            </div>
          </div>
        </div>

        <el-pagination v-show="!noData" background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" :total="total" layout="total,prev, pager, next">
        </el-pagination>
      </el-main>
    </el-container>

  </div>
</template>

<script>
import { isUrl } from '@/common/js/reg'
import Api from '@/api/user'

export default {
  name: 'Favorite',
  data() {
    return {
      pageTitle: '我的收藏',
      currentPage: 1,
      pageSize: 10,
      total: 0,
      itemList: [],
      noData: false
    }
  },
  created() {
    this.getFavoriteList()
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val
      this.getFavoriteList()
    },
    getFavoriteList() {
      const data = {
        page: this.currentPage,
        page_size: this.pageSize
      }
      Api.getFavoriteList(data).then(response => {
        if (response.data.status === 0) {
          this.currentPage = response.data.data.page
          this.pageSize = response.data.data.page_size
          this.total = response.data.data.total
          let list = response.data.data.list
          for (let i = 0; i < list.length; i++) {
            list[i].thumbnail_path = isUrl(list[i].thumbnail_path) ? list[i].thumbnail_path : window.staticsHost + list[i].thumbnail_path
          }
          this.itemList = list
          if (response.data.data.total === 0) {
            this.noData = true
          } else {
            this.noData = false
          }
        }
      })
    },
    goDetail(item) {
      this.$router.push({
        path: '/micro/resource/resource_detail',
        query: {
          id: item.id
        }
      })
    }
  }
}
</script>

<style scoped lang="stylus">
.favorite {
  position: relative;
  width: 100%;

  .el-container {
    .el-header {
      height: 40px !important;
      padding: 0 5px;

      .page-title {
        font-size: 18px;
        text-align: left;
        border-left: 4px solid #559af8;
        color: #515151;
        padding-left: 10px;
      }
    }

    .el-main {
      padding: 0;

      .no-data {
        width: 300px;
        height: 200px;
        margin: 100px auto;

        img {
          width: 300px;
        }

        span {
          font-size: 16px;
          color: #929292;
        }
      }

      .item-list {
        width: clac(100% - 40px);
        min-width: 960px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;

        .item {
          width: calc(20% - 10px);
          min-width: 168px;
          margin: 15px 5px;
          border-radius: 14px;
          box-shadow: 5px 5px 10px 1px #ecf1ff;
          cursor: pointer;
          transition: 0.4s;

          &:hover {
            box-shadow: 0px 0px 8px 5px #dfdfdf;
          }

          .cover {
            position: relative;
            width: 100%;
            height: calc((15vw * 9 / 16));
            min-height: 121.5px;
            border-top-left-radius: 14px;
            border-top-right-radius: 14px;
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;

            .statistics {
              position: absolute;
              width: calc(100% - 30px);
              padding: 0 15px;
              height: 30px;
              left: 0;
              bottom: 0;
              background: rgba(0, 0, 0, 0.5);
              display: flex;
              align-items: center;
              justify-content: space-between;

              .clicks, .downloads, .favorites {
                display: flex;
                align-items: center;
                justify-content: center;
                color: #dcdcdc;
              }
            }
          }

          .intro {
            text-align: left;
            height: 46px;
            padding: 7px 5px;
            border-bottom-left-radius: 14px;
            border-bottom-right-radius: 14px;

            .name {
              height: 24px;
              padding: 0 5px;
              line-height: 24px;
              font-size: 16px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .teacher {
              height: 22px;
              padding: 0 5px;
              line-height: 22px;
              color: #999;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
    }

    .el-pagination {
      margin-top: 100px;
    }
  }
}
</style>